import React, { useState, useEffect } from "react";
import classNames from "classnames";
import Spinner from "./Spinner";

const Loader = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500); // Change the delay (in milliseconds) to suit your needs

    return () => clearTimeout(timer);
  }, []);

  const loaderClasses = classNames(
    "bg-[#605CA6] z-50 fixed top-0 left-0 w-screen h-screen flex items-center justify-center",
    {
      block: isLoading,
      hidden: !isLoading,
    }
  );

  return (
    <div className={loaderClasses}>
      {isLoading && (
        <div className="flex flex-col items-center justify-center">
          <img
            src="https://staging.emotii-cms.hcx-app.com/uploads/1662490000133_removebg_preview_59e6534705.png"
            alt="Loading"
            className="w-24 h-24"
          />
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default Loader;
